import React from "react";
import AdBanner from "./AdBanner"; // AdBanner 컴포넌트 가져오기
import { Tooltip, Row, Col, notification, Button, FloatButton } from "antd";
import smileys from "./emoji_groups/smileys_&_emotion.json";
import people from "./emoji_groups/people_&_body.json";
import component from "./emoji_groups/component.json";
import animals from "./emoji_groups/animals_&_nature.json";
import food from "./emoji_groups/food_&_drink.json";
import travel from "./emoji_groups/travel_&_places.json";
import activities from "./emoji_groups/activities.json";
import objects from "./emoji_groups/objects.json";
import symbols from "./emoji_groups/symbols.json";
import flags from "./emoji_groups/flags.json";
import "./App.css";


const GROUPS = {
  "Smileys & Emotion": smileys,
  "People & Body": people,
  "Component": component,
  "Animals & Nature": animals,
  "Food & Drink": food,
  "Travel & Places": travel,
  "Activities": activities,
  "Objects": objects,
  "Symbols": symbols,
  "Flags": flags,
};

// Notification 설정
const handleCopy = (emojiChar) => {
  navigator.clipboard.writeText(emojiChar);
  notification.success({
    message: "Copied!",
    description: `The emoji "${emojiChar}" has been copied to your clipboard.`,
    placement: "bottom",
  });
};

// 이모지 이름을 대문자로 변환하는 함수
const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const App = () => {
  return (
    <div className="app">
      {/* Emoji Planet 타이틀 */}
      <h1 className="emoji-title">Emoji Planet 🪐</h1>

      {/* 앵커 버튼 */}
      <div className="button-group">
        {Object.keys(GROUPS).map((groupName) => (
          <Button
            key={groupName}
            onClick={() =>
              document
                .getElementById(groupName)
                ?.scrollIntoView({ behavior: "smooth", block: "start" })
            }
          >
            {groupName}
          </Button>
        ))}
      </div>

      {/* 그룹별 이모지 렌더링 */}
      {Object.entries(GROUPS).map(([groupName, emojis]) => (
        <div key={groupName} id={groupName} className="emoji-group">
          {/* 그룹 제목 */}
          <AdBanner />
          <h2 className="emoji-group-title">{groupName}</h2>

          {/* 이모지 그리드 */}
          <Row className="emoji-grid">
            {emojis.map((emoji) => (
              <Col key={emoji.char}>
                <div
                  className="emoji-item"
                  onClick={() => handleCopy(emoji.char)}
                >
                  <Tooltip title={capitalizeFirstLetter(emoji.name)}>
                    <div className="emoji-char">{emoji.char}</div>
                  </Tooltip>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      ))}

      {/* 우측 하단 FloatButton */}
      <FloatButton.BackTop
      />
    </div>
  );
};

export default App;